import React from "react";
import { func } from "prop-types";

export class ActionBar extends React.Component {
    render() {
        const {
            onCancel,
            onSave,
        } = this.props;
        return (<div className="col-md-12">
            <button type="button" className="btn btn-import" onClick={onSave}><span></span> Import</button>
            <button type="button" className="btn btn-cancel" onClick={onCancel}><span></span> Cancel</button>
        </div>);
    }
}

ActionBar.propTypes = {
    onCancel: func.isRequired,
    onSave: func.isRequired
};



// WEBPACK FOOTER //
// ./app/lib/mapping/views/actionbar/ActionBarJS.js